<template>
    <v-form @submit.prevent="printReport" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Employee Reports</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap> 
                    <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                        Error encountered. Please contact support.
                    </v-alert> 
                    <v-flex xs12 sm12 class="form-content">
                        <v-select
                            label="Select report"
                            :items="report_types"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="code"
                            v-model="reportCode"           
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-content">
                        <v-alert v-if="selected_report" :value="true" color="info" icon="info" outline>
                            {{selected_report.description}}
                        </v-alert>  
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions height="45px">
                <v-spacer></v-spacer>
                <v-btn v-if="selected_report" color="primary" type="submit" :disabled="disabled||!reportCode" :loading="loading" class="mr-20">
                    <v-icon>{{selected_report.icon}}</v-icon>&nbsp;&nbsp;&nbsp;{{selected_report.action}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import employeesApi from '@/api/employees'

export default {
    data () {
        return {
            error: false,
            errorMessage: null,
            reportCode: null,
            loading: false,
            disabled: false,
            report_types: [
                {
                    code: 'EMPLOYEE-STATUS',
                    file_type: 'XLSX',
                    action: 'Export to XLSX',
                    name: 'Employee Status Report',
                    icon: 'fas fa-file-excel',
                    description: `Employee profile, status, and salary summary report`
                }
            ],
            rules: {
                required: value => !!value || 'Required field'
            },
            selectedCutOffId: null,
            selectedTeamId: null,
            selectedPeriod: null
        }   
    },
    methods: {
        printReport() {
            try {
                if (this.$refs.form.validate()) {
                    if (this.reportCode=='EMPLOYEE-STATUS') this.generateEmployeeStatusReport()
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async generateEmployeeStatusReport() {
            try {
                this.loading = true
                const response = await employeesApi.getEmployeesStatusReport()
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download =  this.reportFileName
                link.click()
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
                console.log(error)
            }
        },
        closeDialog() {
            this.$emit('update:dialogReports', false)
        },
    },
    computed: {
        selected_report() {
            if (this.reportCode){
                return this.report_types.find(x => x.code == this.reportCode)
            }
        },
        reportFileName() {
            return `${this.selected_report.code} as of ${this.$moment(new Date()).format('YYYY-MM-DD')}.xlsx`
        },
    },
    created() {}
}
</script>
<style scoped>
.form-content {
    padding: 0px 15px 0px 15px; 
}
</style>